module.exports = __webpack_public_path__ + "img/user.da17622e.png";